import { produce } from 'immer';

const INITIAL_STATE = {
  token: null,
  loading: false,
  error: null,
  success: null,
  senha: null,
  confirma: null,
};

export default function resetpassword(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@resetpassword/CHECK_TOKEN_REQUEST':
        draft.loading = true;
        draft.error = null;
        break;
      case '@resetpassword/CHECK_TOKEN_SUCCESS':
        draft.token = action.payload.token;
        draft.loading = false;
        break;
      case '@resetpassword/RESETPASSWORD_REQUEST':
        draft.senha = action.payload.senha;
        draft.confirma = action.payload.confirma;
        draft.token = action.payload.token;
        draft.loading = true;
        draft.error = null;
        break;
      case '@resetpassword/SENDEMAIL_REQUEST':
        draft.email = action.payload.email;
        draft.loading = true;
        draft.success = null;
        draft.error = null;
        break;
      case '@resetpassword/SENDEMAIL_SUCCESS':
        draft.loading = false;
        draft.success = action.payload.success;
        break;
      case '@resetpassword/CHECK_TOKEN_FAILURE':
        draft.token = null;
        draft.senha = null;
        draft.confirma = null;
        draft.email = null;
        draft.loading = false;
        draft.success = null;
        draft.error = action.payload.error;
        break;
      default:
    }
  });
}
